module.exports = __webpack_public_path__ + "img/dabestr.dfe30d65.svg";